import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { getAuctionView } from '../../data';
import CircularProgress from '@material-ui/core/CircularProgress';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Typography, Button } from '@material-ui/core';

function AuctionLog() {
    const { leagueID } = useParams();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const loadData = async () => {
            try {
                setLoading(true);
                const result = await getAuctionView(leagueID);
                setData(result);
                setError(null);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };
        loadData();
    }, [leagueID]);

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', padding: 40 }}>
                <CircularProgress />
            </div>
        );
    }

    if (error) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', padding: 40 }}>
                <Typography color="error">{error}</Typography>
            </div>
        );
    }

    const log = (data.auctionLog || []).slice().reverse();

    return (
        <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', marginBottom: 50 }}>
            <div style={{ flexBasis: '100%', marginBottom: 20 }}>
                <Typography variant="h6">{data.leagueName} - Auction Log</Typography>
                <div style={{ marginTop: 8 }}>
                    <Link to={`/leagues/${leagueID}/auction`}>
                        <Button variant="outlined" size="small">Squad Composition</Button>
                    </Link>
                    <Link to={`/leagues/${leagueID}`} style={{ marginLeft: 12 }}>
                        <Button variant="outlined" size="small">Back to League</Button>
                    </Link>
                </div>
            </div>

            <TableContainer component={Paper} style={{ maxWidth: 700 }}>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>#</TableCell>
                            <TableCell>Player</TableCell>
                            <TableCell>Team</TableCell>
                            <TableCell>Position</TableCell>
                            <TableCell>Squad</TableCell>
                            <TableCell align="right">Price</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {log.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={6} align="center">
                                    <Typography variant="body2" color="textSecondary">
                                        No auction bids yet
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        )}
                        {log.map((entry, i) => (
                            <TableRow key={i}>
                                <TableCell>{log.length - i}</TableCell>
                                <TableCell>{entry.playerName}</TableCell>
                                <TableCell>{entry.playerTeam}</TableCell>
                                <TableCell>{entry.playerPos}</TableCell>
                                <TableCell>{entry.squadName}</TableCell>
                                <TableCell align="right">{entry.price}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
}

export default AuctionLog;
